import type { Type } from '@angular/core';

import type { SettingsComponentId } from '../models/settings-hub.model';

import { SettingsPaymentMethodsComponent } from './settings-payment-methods/settings-payment-methods.component';

/** The components that handle the settings that are not just a value to save: the page renders the one the setting asks for. */
export const SETTINGS_COMPONENTS: Record<SettingsComponentId, Type<unknown>> = {
    'payment-methods': SettingsPaymentMethodsComponent
};
